import React, { useState } from 'react';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export default function Generate({ incrementGenerationCount }) {
  const [images, setImages] = useState([]);
  const [isDisplayed, setIsDisplayed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [nlSignupStatus, setNlSignupStatus] = useState('');
  const [userPrompt, setUserPrompt] = useState('');
  const [imageUrl, setImageUrl] = useState('https://butterpuppies.s3.us-west-1.amazonaws.com/static/banner.png');
  const [promptText, setPromptText] = useState('Welcome to Butterpuppies!');

  const printme = () => {
    // Define your HTML content for printing
    const myPrintContent = `
      <html>
        <head>
          <title>Print</title>
          <style>
            body {
              font-family: sans-serif;
              text-align: center;
            }
            img {
              width: 100%;
            }
            .signature {
              width: 100%;
              color: grey;
              text-align: center;
              margin-top: 20px;
            }
          </style>
        </head>
        <body>
          <h2><b>${promptText}</b></h2>
          <img src="${imageUrl}" alt="Generated Image">
          <h3>Created by me at www.babyboo.dev</h3>
          <hr>
          <div class="signature">Artist Signature</div>
        </body>
      </html>
    `;
  
    // Open a new window
    const printWindow = window.open('', '_blank');
    if (printWindow) {
      // Write the content to the new window
      printWindow.document.open(); // Ensures the document is ready
      printWindow.document.write(myPrintContent);
  
      // Invoke the print dialog
      printWindow.document.close();
      printWindow.focus(); // Focus is necessary for some browsers
      printWindow.print();
      printWindow.close(); // Optional: Close the window after printing
    }
  };  

  const handleSubmitSignup = async (event) => {
    event.preventDefault(); // Prevent the default form submission behavior
    
    const formData = new FormData(event.target);
    const email = formData.get('email');
  
    if (!email || email.trim() === '') {
      alert('Please enter a valid email address.');
      return;
    }
  
    try {
      // Send the email to the Flask backend
      const response = await fetch(`${API_URL}/api/event_newsletter_su`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });
  
      // Handle the server response
      if (response.ok) {
        const result = await response.json();
        setNlSignupStatus(result["message"]);
      } else {
        const error = await response.json();
        setNlSignupStatus(error["message"]);
      }
    } catch (error) {
      console.error('Error submitting the signup form:', error);
      setNlSignupStatus(error["message"])
    }
  };

  // Handler for input change
  const handleInputChange = (event) => {
    setUserPrompt(event.target.value);
  };

  // Handler for form submission
  const handleSubmit = async (event) => {
    event.preventDefault(); // Prevent default form submission behavior

    if (!userPrompt || userPrompt.trim() === '') {
      console.error('userPrompt is empty or invalid');
      return;
    }

    if (loading) {
      return;
    }

    try {
      setLoading(true);
      const response = await fetch(`${API_URL}/api/generate_image`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ user_prompt: userPrompt }),
      });

      if (response.ok) {
        const contentType = response.headers.get('Content-Type') || '';
        if (contentType.includes('application/json')) {
          const result = await response.json();
          setImageUrl(result.image_url);
          setPromptText(result.user_prompt);
          setLoading(false);
          incrementGenerationCount(); // Correctly call the function to increment the generation count
          setIsDisplayed(true);
        } else {
          const errorText = await response.text();
          console.error('Unexpected response format:', errorText);
          setLoading(false);
        }
      } else {
        const errorText = await response.text();
        setLoading(false);
        console.error(`Failed to fetch: ${response.status} - ${errorText}`);
      }
    } catch (error) {
      setLoading(false);
      console.error('Error submitting form:', error);
    }
  };

  return (
    <>
      <div className="row justify-content-center" style={{ backgroundColor:"#d5f5e3" }} >
        <div className="col-md-6 col-sm-12">
          <div className="text-center">
            {loading ? (
              // Display placeholder while loading
              <img src="/timer.gif" alt="Loading..." className="img-fluid mb-2 mt-2" />
            ) : imageUrl ? (
              // Display the received image
              <img id="coloringpage" className="img-fluid message bot print" src={imageUrl} alt={promptText}/>
            ) : (
              // Fallback content if no image and not loading
              <p>No image to display</p>
            )}
          </div>
          {isDisplayed && 
            <div className='text-center'>
            <button className="btn btn-primary mb-3" onClick={printme}>
                      <b><i className="fa fa-print" aria-hidden="true"></i> Print this image</b>
            </button>
            </div>
          }
        </div>
      </div>
      <div className="row justify-content-center" style={{ backgroundColor:"#d5f5e3" }} >
            <h4 className="mb-3 mt-3 text-center ">What are you coloring today?</h4>
      </div>
      <div className="row justify-content-center" style={{ backgroundColor:"#d5f5e3" }}  >
        <div className="col-md-6 col-sm-12 text-center bs-success-text-emphasis rounded">
          <form onSubmit={handleSubmit}>
            <div className="row">
              <input
                type="text"
                className="form-control mb-2 text-center"
                id="user_prompt"
                name="chat"
                placeholder="Unicorn driving a firetruck"
                onChange={handleInputChange}
                value={userPrompt}
              />
              <input className="btn btn-dark" id="submit" name="submit" type="submit" value={loading ? "Loading..." : "Create a coloring page"} disabled={loading} />
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
